import Home from './homepage'
import Contact from './contact'
import Projects from './projects';
import PrjDetails from './projectDetails';
import Footer from './footer';


import { AnimatePresence } from 'framer-motion';
import { BrowserRouter as Router, Route, Routes, useLocation} from 'react-router-dom';


const AnimatedRoutes = () => {
    const location = useLocation()
    return (          
        <AnimatePresence exitBeforeEnter>
        <Routes>
            <Route path="/" element={<Home />}></Route>
            <Route path="/projects" element={<Projects />}></Route>
            <Route path="/contact" element={<Contact />}></Route>
            <Route path='/project/:pid' element={<PrjDetails />}></Route>
        </Routes> 
            <Footer/>
        </AnimatePresence> 
    );
}
 
export default AnimatedRoutes;